import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';
import { IconHome, IconSize } from '@amzn/stencil-react-components/icons';
import { Col, View } from '@amzn/stencil-react-components/layout';
import { Link } from '@amzn/stencil-react-components/link';
import { Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import './FailureErrorPage.scss';

// SIM-T template to request PXT CMS Admin Console access.
export const ADMIN_CONSOLE_ACCESS_TICKET_URL =
  'https://t.corp.amazon.com/create/templates/a5870455-5d91-4812-bee3-a60a3f31517d';

const AccessDeniedPage = () => (
  <Col
    className={'failure-error-page'}
    alignItems={'center'}
    justifyContent={'flex-start'}
  >
    <View className={'failure-error-content'}>
      <Col alignItems={'center'} gridGap={16}>
        <Text fontSize="T500" fontWeight="bold" textAlign="center">
          You do not have access to this
        </Text>
        <Col gridGap={4} alignItems={'center'}>
          <Text
            fontSize="T300"
            fontWeight="regular"
            textAlign="center"
            color={'neutral70'}
          >
            Your profile is not authorized to view or manage this resource.
          </Text>
          <Text
            fontSize="T300"
            fontWeight="regular"
            textAlign="center"
            color={'neutral70'}
          >
            Request access to the PXT CMS Admin Console using{' '}
            <Link
              href={ADMIN_CONSOLE_ACCESS_TICKET_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              create an access request ticket
            </Link>
            , then sign in again.
          </Text>
        </Col>
        <Button
          variant={ButtonVariant.Primary}
          onClick={() => window.location.assign('/')}
          icon={<IconHome aria-hidden={true} size={IconSize.Medium} />}
        >
          Go to Admin Console Home
        </Button>
      </Col>
    </View>
  </Col>
);

export default AccessDeniedPage;
